import React from "react";
import "./UnauthorizedAccess.scss";

interface UnauthorizedAccessProps {
  onRetry: () => void;
  onContactSupport: () => void;
}

const UnauthorizedAccess: React.FC<UnauthorizedAccessProps> = ({
  onRetry,
  onContactSupport,
}) => {
  return (
    <div className="access-denied-container">
      <div className="access-denied-card">
        <div className="icon-container">
          <i className="fa fa-lock fa-2x"></i>
        </div>
        <h1>Oops! It looks like you don’t have permission.</h1>

        <p>
          We’re sorry, but your account doesn’t have the necessary authorization
          to view this page. If you believe you should have access, please
          contact your system administrator or the IT Help Desk.
        </p>
        <button className="contact-button" onClick={onContactSupport}>
          Contact IT Help Desk
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedAccess;
